export default __webpack_public_path__ + "static/media/newApiFailed-dark.5b59283f.svg";